<template>
  <div class="w-full max-w-md">
    <div
      class="bg-white/90 backdrop-blur rounded-2xl border border-gray-200 shadow-xl overflow-hidden"
    >
      <!-- Header -->
      <div class="px-8 pt-8 pb-6 text-center border-b border-gray-100">
        <span
          class="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-blue-700 bg-blue-50 border border-blue-100 rounded-full px-3 py-1 mb-4"
        >
          <BookOpen class="w-3 h-3" />
          Monthly tuition
        </span>

        <h1 class="text-2xl font-semibold text-gray-900 leading-tight">
          {{ plan?.name }}
        </h1>
        <p v-if="plan?.description" class="text-sm text-gray-500 mt-2 leading-relaxed">
          {{ plan?.description }}
        </p>

        <div class="mt-6 flex items-baseline justify-center gap-1.5">
          <span class="text-4xl font-semibold text-gray-900 tracking-tight">
            {{ plan?.formatted_amount || `$${plan?.amount}` }}
          </span>
          <span class="text-sm text-gray-500">/ {{ plan?.interval || 'month' }}</span>
        </div>
      </div>

      <!-- Features (when defined on the plan) -->
      <div v-if="plan?.features?.length" class="px-8 py-6 border-b border-gray-100">
        <ul class="space-y-3 text-left">
          <li
            v-for="feature in plan.features"
            :key="feature"
            class="flex items-start gap-3 text-sm text-gray-700"
          >
            <CheckCircle2 class="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" />
            {{ feature }}
          </li>
        </ul>
      </div>

      <!-- CTA -->
      <div class="px-8 py-8">
        <button
          @click="$emit('pay')"
          :disabled="isLoading"
          class="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-black text-white text-sm font-medium rounded-xl hover:bg-black/80 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-md"
        >
          <Loader2 v-if="isLoading" class="w-4 h-4 animate-spin" />
          {{ isLoading ? 'Redirecting to checkout…' : 'Pay Monthly Tuition' }}
        </button>
        <p class="flex items-center justify-center gap-1.5 text-xs text-gray-400 mt-3">
          <Lock class="w-3 h-3" />
          Secure payment via Stripe
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BookOpen, CheckCircle2, Loader2, Lock } from 'lucide-vue-next'
import type { Plan } from '@/types/subscription'

interface Props {
  plan: Plan | null
  isLoading?: boolean
}

withDefaults(defineProps<Props>(), {
  isLoading: false
})

defineEmits<{
  pay: []
}>()
</script>
